import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Message = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 4H9C6.237 4 4 6.237 4 9V25C4 26.65 5.35 28 7 28C7.8 28 8.563 27.687 9.125 27.125L11.363 24.875C11.926 24.312 12.688 24 13.488 24H23C25.762 24 28 21.762 28 19V9C28 6.237 25.762 4 23 4ZM26 19C26 20.65 24.65 22 23 22H13.488C12.15 22 10.9 22.525 9.951 23.462L7.714 25.7C7.526 25.888 7.276 25.988 7.001 25.988C6.451 25.988 6.001 25.538 6.001 24.988H6.014C6.001 24.976 6.001 9 6.001 9C6.001 7.35 7.351 6 9.001 6H23.001C24.651 6 26.001 7.35 26.001 9V19H26Z" />
	</svg>
);

export default Message;
